import { z } from "zod";
// Core keys every profile needs. Profiles extend this schema (see profiles/*/PROFIL.md).
// Validated once at startup: a missing key fails the process in the first second.
// Keep in sync with .env.example and docs/KURULUM.md.
export const coreSchema = z.object({
    ENVIRONMENT: z.enum(["local", "test", "production"]).default("local"),
    LOG_LEVEL: z.enum(["debug", "info", "warn", "error"]).default("info"),
    SENTRY_DSN: z.string().optional(),
});
export function parseEnv(source, schema = coreSchema) {
    const result = schema.safeParse(source);
    if (!result.success) {
        const issues = result.error.issues.map((i) => `${i.path.join(".")}: ${i.message}`);
        throw new Error(`Invalid environment:\n${issues.join("\n")}`);
    }
    return result.data;
}
//# sourceMappingURL=env.js.map